// extracted by mini-css-extract-plugin
export default {"list":"App_list__aFiFg"};